import { ActionType } from '@editor/src/js/constants/common-action-type';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { ImagePropsField } from '@src/slide/domain/ui-model/element-modeles/property/image-operation/constant/props-value';
import _get from 'lodash/get';

/**
 * 获取当前model所有的菜单属性对象
 * @param model
 */
export function getMenuValues(model: IPictureModel): { [key: string]: any } {
    return {
        [ActionType.FILLCOLOR]: model.getBackgroundFill?.().getFillInfo(),
        [ActionType.EFFECT]: model.getEffect?.().getEffectCollection(),
        [ActionType.BORDERCOLOR]: model.getBorder?.().getBorderInfo(),
        [ActionType.SIZE_ADJUST]: model.getLock().getLockInfo(),
        [ActionType.INSERT_PICTURE]: { alpha: model.props.style.alpha },
        [ActionType.REGULATE]: {
            contrast: _get(model.props.style, 'image.contrast'),
            brightness: _get(model.props.style, 'image.brightness'),
            sharpenSoften: _get(model.props.style, 'image.sharpenSoften'),
        },
        [ActionType.PICTURE_COLOR]: {
            saturate: _get(model.props.style, 'image.saturate'),
            colorTemperature: _get(model.props.style, 'image.colorTemperature'),
        },
        imageType: model.props.imageType || '',
    };
}
